import React, { PureComponent } from 'react'
import {
  bool, func, oneOf, arrayOf,
} from 'prop-types'
import classNames from 'classnames'
import { Locale, withI18n } from '@active/react-utils/i18n'
import Grid from '@active/react-ui/Grid'
import GridItem from '@active/react-ui/GridItem'

import configs from './config'

import './PaymentMethodSwitch.scss'

class PaymentMethodSwitch extends PureComponent {
  static propTypes = {
    handleAddPaymentMethod: func.isRequired,
    paymentMethodsType: arrayOf(oneOf(['CREDIT_CARD', 'ECHECK', 'ACH'])).isRequired,
    isPrimary: bool,
    hideSubTitle: bool,
    i18n: func.isRequired,
  }

  static defaultProps = {
    isPrimary: false,
    hideSubTitle: false,
  }

  resetPaymentMethod = () => {
    const paymentMethodItemArrs = this.paymentMethodRow.children[0].childNodes
    paymentMethodItemArrs.forEach(pmia => pmia.classList.remove('active'))
  }

  handleClick = e => {
    const itemTarget = e.target
    const { handleAddPaymentMethod, isPrimary } = this.props
    const paymentType = itemTarget.getAttribute('data-type')
    this.resetPaymentMethod()
    if (paymentType) {
      handleAddPaymentMethod(paymentType, isPrimary)
    }
    itemTarget.parentNode.classList.add('active')
  }

  render() {
    const {
      paymentMethodsType, isPrimary, hideSubTitle, i18n,
    } = this.props
    // passport.lib.components.payment.add.title.primary or passport.lib.components.payment.add.title
    const title = `passport.lib.components.${isPrimary ? 'payment.add.title.primary' : 'payment.add.title'}`

    return (
      <div className="checkout-payments checkout__payment-switch">
        <h2 className="checkout__payment-switch--title">
          <Locale id={title} />
        </h2>
        {
          !hideSubTitle
          && (
          <div className="checkout__payment-switch--subtitle">
            <Locale id="passport.lib.components.payment.add.subtitle" />
          </div>
          )
        }
        <div className="checkout_payment-switch__container" ref={r => { this.paymentMethodRow = r }}>
          <Grid fluid justify="between" align="center" id="paymentMethodRow" className="checkout__payment-switch__grid" colGap={0} rowGap={0}>
            {
              paymentMethodsType.map(p => {
                const iconClassName = classNames(
                  configs.icons[p],
                )
                return (
                  <GridItem
                    span={12}
                    spanMd={Math.floor(12 / paymentMethodsType.length)}
                    key={p}
                    className="checkout__payment-switch__item"
                  >
                    <div className="checkout__payment-switch__panel">
                      <div
                        className="checkout__payment-switch__mask"
                        data-type={p}
                        onClick={this.handleClick}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            this.handleClick(e)
                          }
                        }}
                        aria-label={i18n(`passport.lib.components.payment.switch.text.${configs.texts[p]}`)}
                        role="button"
                        tabIndex={0}
                      >
                        <div className="checkout__payment-switch--icon" data-type={p}>
                          <i className={iconClassName} data-type={p} />
                        </div>
                        <div className="checkout__payment-switch__text" data-type={p}>
                          <Locale id={`passport.lib.components.payment.switch.text.${configs.texts[p]}`} />
                        </div>
                      </div>
                    </div>
                  </GridItem>
                )
              })
            }
          </Grid>
        </div>
      </div>
    )
  }
}

export default withI18n(PaymentMethodSwitch)
